module.exports = __webpack_public_path__ + "static/sheldon-6f8b469b9f0515c2172a3f78686f1726.jpg";